import React from "react";
import axios from "axios";
import constant from "../../constant";
import Slider from "react-slick";
import Credentials from "../Credentials";
import "./style.scss";

let settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 2,

  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
};

export default class Step5 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      discount_list: [],
      spacetype_list: [],
      euro_conversion: 0,
      cost_v: 0,
      currencys: 0,
      long_term: "5days",
      avg_price: 0,
      city_name: "",
      country_name: "",
      previewImages: [],
      spacetypes: 1,
      alertPopup: false,
      alertMsg: "",
      alertRedirect: "",
      isLogin: false
    };
  }

  UNSAFE_componentWillMount() {
    //  ReSetting state from local storage
    let local_storage_step2 = JSON.parse(
      localStorage.getItem(this.props.spaceId)
    );
    local_storage_step2 &&
      Object.keys(local_storage_step2).reduce((object, key) => {
        return this.setState({
          [key]: local_storage_step2[key]
        });
      }, {});
  }

  componentDidMount() {
    let _this = this;
    axios
      .get(`${constant.phpHost}action/listing.php`, {
        params: {
          todo: "listing_step4",
          id: this.props.spaceId,
          cost_v: this.state.cost_v,
          currencys: this.state.currencys,
          city_id: this.state.city_id,
          space_type: this.state.spacetypes,
          long_term: this.state.long_term,
          isLongterm: this.state.isLongterm ? 1 : 0
        }
      })
      .then(res => {
        let images = JSON.parse(
          localStorage.getItem(_this.props.spaceId + "_images")
        );
        _this.setState({
          previewImages: images ? images : [],
          discount_list: res.data.discount_list ? res.data.discount_list : [],
          euro_conversion: res.data.euro_conversion,
          avg_price: res.data.avg_price,
          city_name: res.data.city_name,
          country_name: res.data.country_name
        });
      });
  }

  // Bottom Button
  buttonStep = step => {
    if (step === "prev") {
      this.state.isLongterm
        ? this.props.stepButton(3)
        : this.props.stepButton(4);
    } else {
      let O_Auth = JSON.parse(localStorage.getItem("O_Auth"));
      if (O_Auth) {
        this.handleListing(O_Auth.id);
      } else {
        this.setState({
          isLogin: true
        });
      }
    }
  };

  handleLogin = () => {
    this.setState({
      isLogin: !this.state.isLogin
    });
  };

  handleListing = user_id => {
    let data = JSON.parse(localStorage.getItem(this.props.spaceId));
    let images = JSON.parse(
      localStorage.getItem(this.props.spaceId + "_images")
    );
    let video = localStorage.getItem(this.props.spaceId + "_video");

    delete data["spacetype_list"];
    delete data["amenity_list"];
    delete data["time_list"];
    delete data["days"];

    let data_ = new FormData();
    data_.append("space_id", this.props.spaceId);
    data_.append("user_id", user_id);
    data_.append("images", images);
    data_.append("video", video ? video : "");
    data_.append("listing", this.props.listing);
    data_.append("is_login", this.props.isLogin);
    Object.keys(data).map(key => data_.append(key, data[key]));

    axios
      .post(`${constant.phpHost}action/listing.php?todo=add_listing`, data_, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(res => {
        // console.log(res);
        localStorage.removeItem(this.props.spaceId + "_images");
        localStorage.removeItem(this.props.spaceId + "_images_order");
        localStorage.removeItem(this.props.spaceId);

        window.location.href = "/dashboard/hosting";
        this.remove_local_file();
      });
  };

  remove_local_file = () => {
    let data_ = new FormData();
    data_.append("space_id", this.props.spaceId);
    axios
      .post(`${constant.phpHost}action/listing.php?todo=unlink_by_id`, data_)
      .then(res => {});
  };

  render() {
    let {
      previewImages,
      long_term,
      spacetypes,
      amenity_list,
      amenity_checked,
      isLogin
    } = this.state;

    let { spaceId } = this.props;

    let video = localStorage.getItem(spaceId + "_video");

    let imgpath = `${constant.phpHost}limage/temp/`;
    let videopath = `${constant.phpHost}/uploads/Jqimg/temp/${spaceId}/video/${video}`;

    if (this.props.listing === "edit") {
      imgpath = `${constant.phpHost}limage/`;
      videopath = `${constant.s3BucketPath}list_images/${spaceId}/video/${video}`;
    }

    return (
      <div>
        {isLogin ? (
          <Credentials
            handleListing={this.handleListing}
            isPopup={this.handleLogin}
          />
        ) : null}

        <h3 className="heading">Review listing</h3>
        <div className="review_listing">
          {this.state.instant_checked ? (
            <div className="inst_booking">
              <label className="check_list">
                <input type="checkbox" defaultChecked="checked" />
                <span className="checkmark" />
                Instant booking is <b> enabled </b>
              </label>
            </div>
          ) : null}

          <h4>{this.state.title_v}</h4>
          <Slider {...settings}>
            {video ? (
              <video
                className="step5_video"
                poster="/assets/images/video_poster.jpg"
                controls
                disablePictureInPicture
                controlsList="nodownload"
                onClick={({ target: video }) =>
                  video.paused ? video.pause() : video.play()
                }
              >
                <source src={videopath} />
              </video>
            ) : null}
            {previewImages.length > 0
              ? previewImages.map((img, i) => {
                  return (
                    <img
                      src={`${imgpath}${this.props.spaceId}/${img}|700x550`}
                      alt="preview"
                      key={i}
                    />
                  );
                })
              : null}
          </Slider>

          <div className="content_block">
            <div className="left_content">
              <div className="form-group">
                <label>Description</label>
                {this.state.description_v}
              </div>

              <div className="form-group">
                <label>Amenities</label>
                <div className="amenities_list">
                  {amenity_list &&
                    amenity_list
                      .filter(amenity => amenity_checked.includes(amenity.id))
                      .map((amenity, i) => (
                        <label key={i}>
                          <b>&#10004;</b>
                          {amenity.title}
                        </label>
                      ))}
                </div>
              </div>

              <div className="form-group">
                <label>Opening hours</label>
                {this.state.is_alldays_checked ? (
                  <label>
                    <b>&#10004;</b> 24/7
                  </label>
                ) : (
                  this.state.days &&
                  this.state.days
                    .filter((hours, i) => this.state.day_checked[i])
                    .map((hours, i) => (
                      <div key={i} className="open_hours">
                        <span>{hours}</span>
                        <span>:</span>
                        <b>
                          {this.state.cf_time[i]} - {this.state.ct_time[i]}
                        </b>
                      </div>
                    ))
                )}
              </div>

              {!this.state.isLongterm && this.state.discount_list.length > 0 ? (
                <div className="form-group">
                  <label>Discount Price</label>

                  <div className="discount_table">
                    <div className="discount_row head">
                      <label>{spacetypes > 1 ? "Hours" : "Days"}</label>
                      <label>Price</label>
                      <label>Currency</label>
                    </div>
                    {this.state.discount_list.map((dl, i) => (
                      <div className="discount_row" key={i}>
                        <span>{dl.days_dis}</span>
                        <span>{dl.price_dis}</span>
                        <span>{dl.cur_code}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>

            <div className="right_content">
              <div className="form-group">
                <label>Type</label>
                {this.state.spacetype_list.map((spacetype, i) => (
                  <div key={i}>
                    {spacetypes === spacetype.id ? spacetype.title : null}
                  </div>
                ))}
              </div>

              <div className="form-group">
                <label>{spacetypes > 1 ? "Participants" : "Desks"}</label>
                <div>{this.state.no_of_desk}</div>
              </div>

              {!this.state.isLongterm ? (
                <div className="form-group">
                  <label>
                    {spacetypes > 1 ? "Cost per hour" : "Cost per day"}
                  </label>
                  <div>
                    {this.state.currency_code} {this.state.cost_v}
                  </div>
                </div>
              ) : (
                <div className="form-group">
                  <label>
                    {long_term === "5days" ? "Cost per 5 days" : null}
                    {long_term === "2weeks" ? "Cost per 2 weeks" : null}
                    {long_term === "1month" ? "Cost per month" : null}
                    {long_term === "3months" ? "Cost per 3 months" : null}
                  </label>
                  <div>
                    {this.state.currency_code} {this.state.cost_v}
                  </div>
                </div>
              )}

              {this.state.currency_code !== "EUR" ? (
                !this.state.isLongterm ? (
                  <div className="form-group">
                    <label>
                      {spacetypes > 1
                        ? "Cost per hour in EUR"
                        : "Cost Per day in EUR"}
                    </label>
                    <div>&euro; {this.state.euro_conversion.toFixed(2)} </div>
                  </div>
                ) : (
                  <div className="form-group">
                    <label>
                      {long_term === "5days" ? "Cost per 5 days in EUR" : null}
                      {long_term === "2weeks"
                        ? "Cost per 2 weeks in EUR"
                        : null}
                      {long_term === "1month" ? "Cost per month in EUR" : null}
                      {long_term === "3months"
                        ? "Cost per 3 months in EUR"
                        : null}
                    </label>
                    <div>&euro; {this.state.euro_conversion.toFixed(2)} </div>
                  </div>
                )
              ) : (
                ""
              )}

              <div className="form-group">
                <label>
                  The average price in {this.state.city_name},{" "}
                  {this.state.country_name}
                </label>
                <div>&euro; {this.state.avg_price.toFixed(2)}</div>
              </div>

              <div className="form-group">
                <label>Address</label>
                <address>
                  {this.state.address}
                  <br />
                  {this.state.city_name}
                  <br />
                  {this.state.country_name} - {this.state.zip_v}.
                </address>
              </div>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="prev_button">
            <button onClick={() => this.buttonStep("prev")}>
              <span>&#x276E;</span>
              {window.innerWidth < 767 ? "PREV" : "PREVIOUS STEP"}
            </button>
          </div>

          <div className="next_button">
            <button className="save" onClick={() => this.buttonStep("next")}>
              {window.innerWidth < 767 ? "SAVE & EXIT" : "SAVE & EXIT"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
